import {HttpParams} from '@angular/common/http';
import {CustomEncoder} from './custom-encoder';
import {SortDirection} from './sort-direction';

export class UserSearchCriteria {
  public email: string;
  public carrierId: string;
  public subcontractorId: string;
  public role: string;

  constructor() {
    this.email = null;
    this.carrierId = null;
    this.subcontractorId = null;
    this.role = null;
  }

  public reset() {
    this.email = null;
    this.carrierId = null;
    this.subcontractorId = null;
    this.role = null;
  }

  public toQueryParams(page: number, size: number): HttpParams {
    let params = new HttpParams({ encoder: new CustomEncoder() });

    params = params.set('page', page.toString());
    params = params.set('size', size.toString());

    if (this.email != null && this.email.trim().length !== 0) {
      params = params.set('email', this.email.trim());
    }
    if (this.carrierId) {
      params = params.set('carrierId', this.carrierId);
    }
    if (this.subcontractorId) {
      params = params.set('subcontractorId', this.subcontractorId);
    }
    if (this.role) {
      params = params.set('role', this.role);
    }
    return params;
  }

  public toQueryParamsWithDirection(page: number, size: number, direction: SortDirection): HttpParams {
    let params = this.toQueryParams(page, size);
    params = params.set('direction', direction.toString());
    return params;
  }
}
